































import Vue from 'vue'
import AmataList from '@/components/AmataList.vue'
import AmataListItem from '@/components/AmataListItem.vue'
import AmataTabs from '@/components/AmataTabs.vue'
import AmataTabsItem from '@/components/AmataTabsItem.vue'
import Badge from '@/components/Badge.vue'
import infiniteLoading from 'vue-infinite-loading'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import config from '@/config'

export default Vue.extend({
  name: 'Notice',
  components: {
    AmataList,
    AmataListItem,
    AmataTabs,
    AmataTabsItem,
    Badge,
    infiniteLoading
  },
  data() {
    return {
      activeTab: this.$route.params.type === 'syslog' ? '0' : '1'
    }
  },
  computed: {
    ...mapGetters('Notice', ['enabledInfinite', 'infomations', 'syslogs', 'hasUnreadInfo']),

    isSyslog(): boolean {
      return this.$route.params.type === 'syslog'
    },

    isNews(): boolean {
      return this.$route.params.type === 'news'
    }
  },
  watch: {
    async activeTab(this: any, val: string) {
      this.setPage(0)
      this.getNotices(val)
    }
  },
  created(this: any) {
    this.setPage(0)
    this.getNotices(this.activeTab)
  },
  destroyed(this: any) {
    this.checkHasUnreadNotice()
  },
  methods: {
    ...mapMutations('Notice', ['setPage']),
    ...mapActions('Notice', [
      'checkHasUnreadNotice',
      'getInfomations',
      'getSyslogs',
      'infiniteSyslogs'
    ]),

    /**
     * 値に応じてデータをサーバから取得
     */
    async getNotices(this: any, val: string) {
      if (val === '0') {
        await this.getSyslogs()
        this.$router.replace('/notice/syslog')
      } else if (val === '1') {
        await this.getInfomations()
        this.$router.replace('/notice/news')
      }
    },

    /**
     * システム通知の無限スクロール
     */
    onInfinite(this: any, $state) {
      this.infiniteSyslogs($state)
    },

    /**
     * ニュースナンバーを持っているかどうか
     */
    hasNewsNumber(newsKey: string): boolean {
      const number = this.getNewsNumber(newsKey)
      return this.$route.params.no === number || this.$route.query.no === number
    },

    /**
     * ニュースナンバーの取得
     */
    getNewsNumber(newsKey: string): string {
      return newsKey.split('_')[1]
    },

    /**
     * ページジャンプ
     */
    jump(this: any, url: string) {
      if (!url) {
        return
      }
      if (url[0] === '#') {
        // アプリ内遷移
        location.href = url
      } else if (~url.indexOf(config.SERVER_URL)) {
        // アプリ内ブラウザ
        this.$_open(url + this.$_appBrowserQuery)
      }
    }
  }
})
